export default __webpack_public_path__ + "static/media/gallery-wip-pommel_01.ece427d3.jpg";